<template>
  <v-container v-if="credits">
    <page-header :title="`${credits.title} ${credits.version}`" :info="lang.apiInfo(credits.author, credits.email, credits.links)" />
    <h3 :class="['title', 'font-weight-light', 'mb-4']" v-html="lang.repositories" />
    <v-list v-if="routes.length" dense two-line>
      <template v-for="(repo, index) in credits.repos">
        <v-list-tile ripple :key="index" :href="repo.url" target="_blank" :title="lang.viewCode">
          <v-list-tile-action>
            <v-icon>mdi-bitbucket</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-html="repo.url" />
            <v-list-tile-sub-title v-html="repo.name" />
          </v-list-tile-content>
          <chevron-right />
        </v-list-tile>
        <v-divider :key="index + '-divider'" v-if="index < credits.repos.length - 1" />
      </template>
    </v-list>
    <h3 :class="['title', 'font-weight-light', 'my-4']" v-html="lang.apiRoutes" />
    <v-list v-if="routes.length" dense three-line>
      <template v-for="(route, index) in routes">
        <v-list-tile ripple :key="index" :href="route.url" target="_blank" :title="lang.getPayload">
          <v-list-tile-action>
            <v-icon>mdi-code-tags</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-html="route.url" />
            <v-list-tile-sub-title v-html="route.description" />
            <v-list-tile-sub-title>{{ lang.httpMethods }}: {{ route.methods.join(', ') }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <chevron-right />
        </v-list-tile>
        <v-divider :key="index + '-divider'" v-if="index < routes.length - 1" />
      </template>
    </v-list>
    <div hidden v-html="`${credits.title} ${credits.version}`" :class="['meta-description']" />
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'api',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      routes: [],
      credits: null
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Mounted event handler
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      const cache = this.getCachedPage('page', 'api')
      cache ? this.done(cache) : this.getCredits()
    },
    /**
     * Get the page data from the API
     * @method getHelpPage
     * @return {void}
     */
    getApiPage () {
      this.routes = this.$root.routes
      this.$nextTick(() => {
        this.emitRouteChange()
      })
    },
    /**
     * Get the page data from the API
     * @method getCredits
     * @return {void}
     */
    getCredits () {
      this.id = this.$route.params.id
      const url = this.$root.routes.find(route => route.url.includes('credits')).url
      this.$http(url)
        .then(response => {
          this.done(response.data.payload)
        })
    },
    /**
     * Process the data from API or from the cache
     * @method done
     * @param {object} response [response=null]
     * @return {void}
     */
    done (response = null) {
      this.getApiPage()
      this.credits = response
      this.$nextTick(() => {
        this.emitRouteChange()
        this.setLastBreadcrumbsItemText(this.lang.api)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/api.vue